module.exports = __webpack_public_path__ + "static/druid_wild_companion-54459f1d0d70b7093a314dfaaa1b2cb5.png";